import ProvinceConsumptionListComponent from "components/ProvinceConsumption/list"
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
  exportProvinceConsumptions,
  getProvinceConsumptions,
  getProvinceConsumptionsProviderAccount,
  getProvinceConsumptionsProvinces,
  storeProvinceConsumptions,
  storeBatchProvinceConsumptions,
  updateProvinceConsumptions,
} from "store/province-consumptions/province-consumption-action"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { provinceConsumptionAction } from "store/province-consumptions/province-consumption-slice"

const ProvinceConsumptionList = () => {
  // Meta Title
  document.title = "Consumptions"

  const [filters, setfilter] = useState({})
  const dispatch = useDispatch()
  const {
    data,
    error,
    loading,
    export: exportStatus,
  } = useSelector(state => ({
    data: state.provinceConsumptions.data,
    error: state.provinceConsumptions.error,
    loading: state.provinceConsumptions.loading,
    export: state.provinceConsumptions.export,
  }))

  // Retrieve store Status  data from Redux store
  const storeStatus = useSelector(state => state.provinceConsumptions.store)

  // Executes when the advanced search form is submitted
  const onAdvancedSearchSubmit = values => {
    setfilter(values)
    dispatch(getProvinceConsumptions(values))
  }
  // Trigger export process when Export button is clicked
  const onExport = () => {
    dispatch(exportProvinceConsumptions(filters))
  }

  // fetch consumptin and provider acount users for filter
  useEffect(() => {
    dispatch(getProvinceConsumptions())
    dispatch(getProvinceConsumptionsProviderAccount())

    return () => {
      dispatch(provinceConsumptionAction.resetState())
    }
  }, [])

  /*
  - onSubmit: Triggered when the form is submitted
  - values: Contains the form input values
  - Dispatches the action to store the Consumption with the provided values
*/
  const onSubmit = value => {
    value.year = filters?.year ? filters.year : new Date().getFullYear()
    value.month = filters?.month
      ? filters.month
      : ("0" + (new Date().getMonth() + 1)).slice(-2)

    value.consume = value.quantity
    dispatch(storeProvinceConsumptions(value))
  }

  /*
  - onUpdateFunc: Triggered when the form is submitted
  - values: Contains the form input values
  - Dispatches the action to update the Consumption with the provided values
*/
  const onUpdateFunc = value => {
    dispatch(updateProvinceConsumptions(value))
  }

  /*
  - onBatchSave: Triggered when Save All button is clicked
  - consumptions: Array of pending consumption entries
  - Dispatches the action to store multiple consumptions in batch
*/
  const onBatchSave = (consumptions) => {
    dispatch(storeBatchProvinceConsumptions(consumptions, filters))
  }

  return (
    <React.Fragment>
      <Breadcrumbs title={"Province"} breadcrumbItem={"Consumptions"} />
      {/* Province Consumption Component  */}
      <ProvinceConsumptionListComponent
        data={data?.data}
        loading={loading}
        error={error}
        onAdvancedSearchSubmit={onAdvancedSearchSubmit}
        onUpdateFunc={onUpdateFunc}
        onSubmit={onSubmit}
        onBatchSave={onBatchSave}
        filters={filters}
        storeStatus={storeStatus}
        onExport={onExport}
        exportLoading={exportStatus?.loading}
      />
    </React.Fragment>
  )
}

export default ProvinceConsumptionList
